import useSWRMutation, { type SWRMutationResponse } from "swr/mutation";
import { useApiClient } from "@/hooks/useApiClient";
import { isAxiosError } from "axios";
import type {
  OwnerRelatedRegistriesQuery,
  OwnerRelatedRegistryResponse,
} from "@/types/ownerRelatedRegistries";

const endpoint = "/owner-related/owner-related-registries";

export type OwnerRelatedRegistriesMutation = SWRMutationResponse<
  OwnerRelatedRegistryResponse[],
  never,
  string,
  OwnerRelatedRegistriesQuery
>;

export const useOwnerRelatedRegistriesMutation =
  (): OwnerRelatedRegistriesMutation => {
    const { apiClient } = useApiClient();

    const fetcher = async (
      url: string,
      { arg }: { arg: OwnerRelatedRegistriesQuery }
    ): Promise<OwnerRelatedRegistryResponse[]> => {
      try {
        const response = await apiClient.get<OwnerRelatedRegistryResponse[]>(
          url,
          {
            params: arg,
          }
        );
        return response.data;
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          return [];
        }
        throw error;
      }
    };

    return useSWRMutation(endpoint, fetcher, { revalidate: false });
  };
